module.exports = __webpack_public_path__ + "img/rf3.1d18774e.png";